import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { validateFormData } from "../../../utils/validation";
import { errorMsg, successMsg } from "../../../utils/customFn";
import useApiRequest from "../../../hook/useApiRequest";
import Joi from "joi";
import { API_ENDPOINTS } from "../../../constants/endPoints";

const useFaqsUtils = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loading, fetchData } = useApiRequest();
  const [formErrors, setFormErrors] = useState({});
  const [faqs, setFaqs] = useState([{ id: null, question: "", answer: "" }]);
  const languageId = localStorage.getItem("language_id") || "1";
  const [delete_ids, setdeleteIds] = useState([]);
  const [language_id, setLanguageId] = useState(languageId);

  

  const fetchFaqData = async () => {
    const response = await fetchData(
      `${API_ENDPOINTS?.get_faqs}?language_id=${encodeURIComponent(language_id)}`,

      navigate
    );
    if (response) {
      const formattedFaqs = response.map((faq) => ({
        id: faq.id,
        question: faq.faq_descriptions?.question || "",
        answer: faq.faq_descriptions?.answer || "",
      }));
      setFaqs(formattedFaqs);
    } else {
      setFaqs([{ id: null, question: "", answer: "" }]);
    }
  };

  useEffect(() => {
    fetchFaqData();
  }, [language_id]);

  console.log("delete_ids",delete_ids)

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      const finalData = {
        "question[]": faqs.map((faq) => faq.question),
        "answer[]": faqs.map((faq) => faq.answer),
        "id[]": faqs.map((faq) => faq.id || ""),
        language_id: language_id,
        delete_ids
      };

      const url = `${API_ENDPOINTS.update_faqs}`;
      const response = await fetchData(url, navigate, "PATCH", finalData);

      if (response) {
        successMsg("Faqs has been successfully updated.");
      }
    } catch (err) {
      console.error("Error during form submission:", err);
    }
  };

  const handleFAQChange = (index, field, value) => {
    const updatedFaqs = [...faqs];
    updatedFaqs[index][field] = value;
    setFaqs(updatedFaqs);
  };

  const addFAQ = () => {
    setFaqs([...faqs, { id: null, question: "", answer: "" }]);
  };

  const removeFAQ = (index) => {
    if (faqs.length > 1) {
      setdeleteIds((prev) => [...prev, faqs[index]?.id]);
    
      setFaqs(faqs.filter((_, i) => i !== index));
    }
  };

  return {
    loading,
    fetchData,
    submitForm,
    formErrors,
    faqs,
    handleFAQChange,
    addFAQ,
    removeFAQ,
    setLanguageId,
    language_id
    
  };
};

export default useFaqsUtils;
